export default __webpack_public_path__ + "alberta-therapy-miscellaneous.8ccd45cf3a4f0f672622.svg";